import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

class RepeaterImageRight {
    constructor(root) {
        this.root = root;
        this.title = this.root.querySelector('[data-repeater--title]');
        this.text = this.root.querySelector('[data-repeater--text]');
        this.image = this.root.querySelectorAll('[data-repeater--image]');
        
        this.init();
    }

    init() {

        this.timeline = gsap.timeline({
            scrollTrigger: {
                trigger: this.root,
                start: 'top 90%',
                end: 'bottom 10%',
                invalidateOnRefresh: true,
                // markers: true,
            },
        })
            .fromTo(this.text, {
                opacity: 0,
            }, {
                opacity: 1,
                duration: 0.3,
                ease: 'out',
            }, '#start')
            .fromTo(this.title, {
                opacity: 0,
            }, {
                opacity: 1,
                duration: 0.3,
                ease: 'out',
            }, '#start')
            .fromTo(this.image, {
                opacity: 0,
                xPercent: () => {
                    let xPercent = this.root.getAttribute('data-repeater--reverse') !== null ? -10 : 10;
                    if (window.innerWidth < 768) { xPercent = 0; }

                    return xPercent;
                },
            }, {
                opacity: 1,
                xPercent: 0,
                duration: 0.7,
                stagger: 0.1,
                ease: 'out',
            }, '#start+=0.1');
    }

    destroy() {
        this.anim && this.anim.kill();
    }
}

export default {
    when() {
        return document.querySelectorAll('[data-repeater]').length > 0;
    },

    created() {
        this.instances = [];
        document.querySelectorAll('[data-repeater]').forEach(grid => {
            const instance = new RepeaterImageRight(grid);
            this.instances.push(instance);
        });
    },

    destroyed() {
        this.instances.forEach(instance => {
            instance.destroy && instance.destroy();
        });
    }
}
